import { render, staticRenderFns } from "./APBiology.vue?vue&type=template&id=4f65aa06&scoped=true&"
import script from "./APBiology.vue?vue&type=script&lang=js&"
export * from "./APBiology.vue?vue&type=script&lang=js&"
import style0 from "./APBiology.vue?vue&type=style&index=0&id=4f65aa06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f65aa06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VRow,VToolbar})
